var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 11V6.39394C13 6.00296 12.5714 5.76326 12.2383 5.96791L8.52342 8.2499C8.20234 8.44713 7.79766 8.44713 7.47658 8.2499L3.76171 5.96791C3.42856 5.76326 3 6.00296 3 6.39394V11C3 11.5523 3.44772 12 4 12H12C12.5523 12 13 11.5523 13 11Z",
    fill: "#002A69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.532 7.66984L12.834 5C12.9209 4.47641 12.5171 4 11.9863 4H4.03093C3.5074 4 3.12336 4.49217 3.25065 5L7.47064 7.66562C7.79443 7.87015 8.20659 7.87179 8.532 7.66984Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailFill);
export default __webpack_public_path__ + "static/media/Mail_fill.3c4e74544fd98f85070ffee54aa09836.svg";
export { ForwardRef as ReactComponent };